import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'
import { css } from 'emotion'
import ModalVideo from 'react-modal-video'

import Section from '../components/section'
import MainHero from '../components/main/hero'
import Button from '../components/buttons/Button'
import PartnersList from '../components/main/PartnersList'
import FeatureList from '../components/main/FeatureList'
import HowItWorks from '../components/main/HowItWorks'

import 'react-modal-video/scss/modal-video.scss'

const partnersClass = css`
  position: relative;
`

const PartnersHeaderWrapper = styled.div`
  text-align: center;
`

const SectionHeader = styled.h3`
  text-align: center;
  font-size: 36px;
  font-weight: bold;
`

const PartnersButton = css`
  @media (min-width: 1025px) {
    display: none;
  }
`

const SubH3 = styled.h3`
  font-weight: 300;
  margin-bottom: 2rem;
`

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openVideo: false
    }
  }

  render() {
    console.log(this.props)
    return (
      <div>
        <Section>
          <MainHero
            header={`Your Hotel’s Digital Front Desk`}
            subHeader={
              <div>
                <SubH3>Integrated with your favorite tools, Whistle is the all-in-one to streamline front office operations.</SubH3>
                <span>Automated Guest Messaging | Team Collaboration <br/> Upselling | Task Management</span>
              </div>
            }
            toggleVideo={() => this.setState({ openVideo: true })}
          />
        </Section>
        <Section id="partners" light className={partnersClass} animated>
          <PartnersHeaderWrapper>
            <SectionHeader>Integrations & Partners</SectionHeader>
            <Button anchor secondary to={'/testimonials'} className={PartnersButton}>Read their Stories</Button>
          </PartnersHeaderWrapper>
          <PartnersList
            partners={this.props.data.allMarkdownRemark.edges}
          />
        </Section>
        <Section id="how-it-works" animated>
          <SectionHeader>How It Works</SectionHeader>
          <HowItWorks
            toggleVideo={() => this.setState({ openVideo: true })}
          />
        </Section>
        <Section id="features" light animated>
          <SectionHeader>The Whistle Platform</SectionHeader>
          <FeatureList />
        </Section>
        <ModalVideo
          channel='vimeo'
          isOpen={this.state.openVideo}
          videoId='258364855'
          onClose={() => this.setState({ openVideo: false })}
        />
      </div>
    )
  }
}

export const pageQuery = graphql`
  query PartnersQuery {
    allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___order] },
      filter: { frontmatter: { templateKey: { eq: "partner" } }}
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            logo
            order
          }
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js